import React from 'react';
import { Phone, MapPin, Clock, Mail, Star } from 'lucide-react';
import { restaurantInfo, hours } from '../data/mock';

const Footer = () => {
  const todayHours = hours[new Date().toLocaleDateString('en-US', { weekday: 'long' })];

  return (
    <footer className="footer-custom">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Restaurant Info */}
          <div className="md:col-span-1">
            <h3 className="text-xl font-bold mb-4" style={{ fontFamily: 'var(--font-serif)' }}>
              Imani Food
            </h3>
            <p className="text-gray-300 mb-4">
              Authentic African & Antillean cuisine in the heart of Meyrin. 
              Experience the rich flavors of traditional dishes made with love.
            </p>
            <div className="flex items-center space-x-1 text-yellow-400">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={16} fill="currentColor" />
              ))}
              <span className="text-white ml-2">4.5 ({restaurantInfo.totalReviews} reviews)</span>
            </div>
          </div>

          {/* Contact Info */}
          <div className="md:col-span-1">
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <MapPin size={16} className="text-gray-400 mt-1 flex-shrink-0" />
                <span className="text-gray-300">{restaurantInfo.address}</span>
              </div>
              <div className="flex items-center space-x-3">
                <Phone size={16} className="text-gray-400" />
                <span className="text-gray-300">{restaurantInfo.phone}</span>
              </div>
              <div className="flex items-center space-x-3">
                <Mail size={16} className="text-gray-400" />
                <span className="text-gray-300">info@imanifood.ch</span>
              </div>
            </div>
          </div>

          {/* Hours */}
          <div className="md:col-span-1">
            <h4 className="text-lg font-semibold mb-4">Opening Hours</h4>
            <div className="space-y-2">
              {Object.entries(hours).map(([day, time]) => (
                <div key={day} className="flex justify-between text-sm">
                  <span className={`text-gray-300 ${day === new Date().toLocaleDateString('en-US', { weekday: 'long' }) ? 'font-semibold text-white' : ''}`}>
                    {day}
                  </span>
                  <span className={`text-gray-300 ${day === new Date().toLocaleDateString('en-US', { weekday: 'long' }) ? 'font-semibold text-white' : ''}`}>
                    {time}
                  </span>
                </div>
              ))}
            </div>
            {todayHours && (
              <div className="mt-4 p-3 bg-green-600 rounded-lg">
                <div className="flex items-center space-x-2">
                  <Clock size={16} />
                  <span className="text-sm font-medium">Open Today: {todayHours}</span>
                </div>
              </div>
            )}
          </div>

          {/* Services */}
          <div className="md:col-span-1">
            <h4 className="text-lg font-semibold mb-4">Services</h4>
            <div className="space-y-2">
              <div className="text-gray-300">✓ Dine-in</div>
              <div className="text-gray-300">✓ Takeaway</div>
              <div className="text-gray-300">✓ Delivery</div>
              <div className="text-gray-300">✓ Reservations</div>
              <div className="text-gray-300">✓ Catering</div>
              <div className="text-gray-300">✓ Wheelchair Accessible</div>
            </div>
            <div className="mt-4">
              <p className="text-sm text-gray-400">
                Price Range: {restaurantInfo.priceRange}
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-400 text-sm">
            © 2024 Imani Food. All rights reserved.
          </div><br />
          <div className="flex flex-col md:flex-row justify-between items-center">
             <span className="text-white-400 text-sm">
                Developed and maintained with ❤️ by <strong><a href="https://ai.hridx.tech/" className="text-amber-400 underline underline-offset-4">HridxAI</a></strong>...
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
